<div class="row" *ngIf="result == ''">
    <div class="col-md-12 need-config">
        <div class="row">
            <div class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
                <div class="card block shadow">
                    <div class="card-header">
                        <div class="card-title">
                            <h2>Analyser un DPE</h2>
                        </div>
                    </div>
                    <div class="card-body col-md-12">
                        <div class="card-text row">
                            <div class="col-md-12">
                                <div [ngClass]="{'d-none': loading}">
                                    <p>
                                        Notre intelligence artificielle récupère le DPE officiel auprès de l'ADEME et l'analyse :
                                        étiquettes énergie et climat, déperditions, travaux à prévoir, optimisations possibles,
                                        conseils et points à vérifier.
                                    </p>
                                    <div class="info-box info-box-warning mb-3" *ngIf="blockedKind !== ''">
                                        <i class="fa fa-exclamation-triangle"></i>
                                        <span>
                                            {{ blockedMessage }}
                                            <ng-container *ngIf="blockedKind === 'credit' && aiCreditService.renewDate !== ''">
                                                Vos prochains crédits seront disponibles le {{ aiCreditService.renewDate | date:'dd/MM/yyyy' }}.
                                            </ng-container>
                                            <br/>
                                            <a [routerLink]="[aiCreditService.planUrl]">
                                                <b *ngIf="blockedKind === 'credit'">Passer à un forfait supérieur</b>
                                                <b *ngIf="blockedKind === 'plan'">Voir les forfaits</b>
                                            </a>
                                        </span>
                                    </div>
                                    <app-ademe-input [(value)]="refAdeme" [showImage]="false"></app-ademe-input>
                                    <p class="text-muted fs-small mt-2 mb-0" *ngIf="blockedKind === ''">
                                        <i class="fa cfa cfa-star me-1"></i>
                                        L'analyse consomme 1 crédit IA. Il vous en reste <b>{{ aiCreditService.credit }}</b><ng-container *ngIf="aiCreditService.renewDate !== ''">, prochaine recharge le {{ aiCreditService.renewDate | date:'dd/MM/yyyy' }}</ng-container>.
                                    </p>
                                </div>
                                <div [ngClass]="{'d-none': !loading}">
                                    <mat-spinner diameter="50" color="second" class="float-left me-5"></mat-spinner>
                                    Récupération et analyse du DPE en cours ...<br/>
                                    Cela peut prendre jusqu'à une minute.<br/>
                                    <br/>
                                </div>
                            </div>

                            <div class="col-12">
                                <div [ngClass]="{'d-none': loading}">
                                    <button (click)="analyse()" class="btn d-block" [disabled]="refAdeme.trim() == '' || blockedKind !== ''">
                                        <i class="fa fa-line-chart"></i> Analyser le DPE
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row" *ngIf="result != ''">
    <div class="col-12">
        <div class="card block">
            <div class="card-header">
                <div class="card-title">
                    <h2>Analyse du DPE {{ analysedRef }}</h2>
                </div>
            </div>
            <div class="card-body col-md-12">
                <div class="card-text row">
                    <div class="col-md-12">
                        <span class="text-muted fs-small">
                            Analyse du {{ analysedDate | date:'dd/MM/yyyy à HH:mm' }}
                        </span>
                        <app-ai-result [result]="result" class="d-block mt-2"></app-ai-result>
                    </div>
                    <div class="col-12">
                        <button (click)="newAnalysis()" class="btn btn-outline">
                            <i class="fa fa-refresh"></i> Analyser un autre DPE
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
